/**
 * Pokemon Data Normalization Utilities
 * จัดการการ map ชื่อโปเกมอนและท่าต่อสู้ให้ตรงกันทั้งเว็บ
 */

import { getApiBaseUrl } from './apiUrl';

// Pokemon name mapping (will be loaded from CSV)
let pokemonNameMap = new Map();
let pokemonNameMapByEnglish = new Map();
let pokemonNameMapByThai = new Map();

// Move name mapping (will be loaded from CSV)
let moveNameMap = new Map();
let moveNameMapByEnglish = new Map();
let moveNameMapByThai = new Map();

/**
 * Load Pokemon names mapping from CSV data
 * This should be called once at app initialization
 */
export const loadPokemonNameMapping = async () => {
  try {
    // For now, we'll build the map from the data structure provided
    // In production, this would load from CSV file or API
    const mappingData = [
      { id: 'pokemon_name_0001', name_english: 'Bulbasaur', name_thai: 'ฟุชิกิดาเนะ' },
      { id: 'pokemon_name_0002', name_english: 'Ivysaur', name_thai: 'ฟุชิกิโซ' },
      { id: 'pokemon_name_0003', name_english: 'Venusaur', name_thai: 'ฟุชิกิบานะ' },
      { id: 'pokemon_name_0006', name_english: 'Charizard', name_thai: 'ลิซาร์ดอน' },
      { id: 'pokemon_name_0150', name_english: 'Mewtwo', name_thai: 'มิวทู' },
      { id: 'pokemon_name_0448', name_english: 'Lucario', name_thai: 'ลูคาริโอ' },
      { id: 'pokemon_name_0612', name_english: 'Haxorus', name_thai: 'โอโนโนคุส' },
      { id: 'pokemon_name_0376', name_english: 'Metagross', name_thai: 'เมทากรอส' },
      { id: 'pokemon_name_0130', name_english: 'Gyarados', name_thai: 'เกียราดอส' },
      { id: 'pokemon_name_0149', name_english: 'Dragonite', name_thai: 'ไคริว' },
      { id: 'pokemon_name_0468', name_english: 'Togekiss', name_thai: 'โทเกคิส' },
      { id: 'pokemon_name_0671', name_english: 'Florges', name_thai: 'ฟลาเจส' },
      { id: 'pokemon_name_0464', name_english: 'Rhyperior', name_thai: 'โดไซดอน' },
      { id: 'pokemon_name_0445', name_english: 'Garchomp', name_thai: 'กาเบรียส' },
    ];
    
    mappingData.forEach(item => {
      pokemonNameMap.set(item.id, item);
      pokemonNameMapByEnglish.set(item.name_english.toLowerCase(), item);
      pokemonNameMapByThai.set(item.name_thai, item);
    });
    
    console.log('[POKEMON MAP] Loaded', mappingData.length, 'pokemon name mappings');
  } catch (error) {
    console.error('[POKEMON MAP] Error loading mapping:', error);
  }
};

/**
 * Load Move names mapping from CSV data
 */
export const loadMoveNameMapping = async () => {
  try {
    const mappingData = [
      { id: 'move_name_0001', move_english: 'Thunder Shock', move_thai: 'ช็อกไฟฟ้า' },
      { id: 'move_name_0002', move_english: 'Quick Attack', move_thai: 'เคลื่อนที่ความไวแสง' },
      { id: 'move_name_0068', move_english: 'Shadow Claw', move_thai: 'ชาโดว์คลอว์' },
      { id: 'move_name_0093', move_english: 'Mud Shot', move_thai: 'มัดช็อต' },
      { id: 'move_name_0094', move_english: 'Bone Club', move_thai: 'ตะบองกระดูก' },
      { id: 'move_name_0213', move_english: 'Shadow Claw', move_thai: 'ชาโดว์คลอว์' },
      { id: 'move_name_0216', move_english: 'Mud Shot', move_thai: 'มัดช็อต' },
      { id: 'move_name_0025', move_english: 'Sucker Punch', move_thai: 'โจมตีแบบไม่คาดคิด' },
      { id: 'move_name_0203', move_english: 'Sucker Punch', move_thai: 'โจมตีแบบไม่คาดคิด' },
      { id: 'move_name_0204', move_english: 'Dragon Breath', move_thai: 'ลมหายใจมังกร' },
      { id: 'move_name_0081', move_english: 'Dragon Breath', move_thai: 'ลมหายใจมังกร' },
      { id: 'move_name_0058', move_english: 'Aqua Tail', move_thai: 'อควาเทล' },
      { id: 'move_name_0024', move_english: 'Flamethrower', move_thai: 'พ่นไฟ' },
      { id: 'move_name_0005', move_english: 'Vine Whip', move_thai: 'แส้เถาวัลย์' },
      { id: 'move_name_0011', move_english: 'Pound', move_thai: 'ปัด' },
      { id: 'move_name_0037', move_english: 'Peck', move_thai: 'จิก' },
      { id: 'move_name_0086', move_english: 'Dazzling Gleam', move_thai: 'เมจิคัลไชน์' },
      { id: 'move_name_0087', move_english: 'Moonblast', move_thai: 'มูนฟอร์ซ' },
      { id: 'move_name_0031', move_english: 'Earthquake', move_thai: 'แผ่นดินไหว' },
      { id: 'move_name_0379', move_english: 'Breaking Swipe', move_thai: 'ไวด์เบรกเกอร์' },
      { id: 'move_name_0334', move_english: 'Rock Wrecker', move_thai: 'ปีนใหญ่หิน' },
      { id: 'move_name_0030', move_english: 'Meteor Mash', move_thai: 'โคเม็ทพันช์' },
    ];
    
    mappingData.forEach(item => {
      moveNameMap.set(item.id, item);
      moveNameMapByEnglish.set(item.move_english.toLowerCase(), item);
      moveNameMapByThai.set(item.move_thai, item);
    });
    
    console.log('[MOVE MAP] Loaded', mappingData.length, 'move name mappings');
  } catch (error) {
    console.error('[MOVE MAP] Error loading mapping:', error);
  }
};

// Load mappings from API endpoint
let mappingsLoaded = false;

/**
 * Load mappings from API endpoint
 * รองรับรูปแบบ underscore: gourgeist_large, ninetales_alolan
 */
export const loadMappingsFromAPI = async () => {
  if (mappingsLoaded) return;
  
  try {
    const apiUrl = getApiBaseUrl();
    
    // Load Pokemon mappings
    const pokemonResponse = await fetch(`${apiUrl}/api/mapping/pokemon`);
    if (pokemonResponse.ok) {
      const pokemonData = await pokemonResponse.json();
      if (pokemonData.success && pokemonData.data) {
        pokemonData.data.forEach(item => {
          // Extract ID - handle both "0001" and "0038_alolan" formats
          const fullId = item.id || item.pokemon_id || '';
          const id = fullId.replace('pokemon_name_', '') || fullId;
          
          // Store mapping with multiple keys for fast lookup
          pokemonNameMap.set(id, item);
          
          // Index by English name (lowercase)
          if (item.name_english) {
            const nameEnLower = item.name_english.toLowerCase();
            pokemonNameMapByEnglish.set(nameEnLower, item);
            // Also index without spaces/underscores for flexible matching
            pokemonNameMapByEnglish.set(nameEnLower.replace(/[_\s]/g, ''), item);
          }
          
          // Index by Thai name
          if (item.name_thai) {
            pokemonNameMapByThai.set(item.name_thai, item);
          }
          
          // Index by species_id if available (e.g., "gourgeist_large", "ninetales_alolan")
          // This is CRITICAL for underscore pattern matching
          if (item.name_species_id) {
            const speciesIdLower = item.name_species_id.toLowerCase();
            pokemonNameMap.set(speciesIdLower, item);
            // Also index without underscores for flexible matching
            if (speciesIdLower.includes('_')) {
              pokemonNameMap.set(speciesIdLower.replace(/_/g, ''), item);
              pokemonNameMap.set(speciesIdLower.split('_')[0], item);
            }
          }
          
          // Index by base_pokemon_id (numeric only - remove variant suffix)
          if (item.base_pokemon_id) {
            // Clean base_pokemon_id - should be numeric only (e.g., "711" not "711_large")
            const cleanBaseId = String(item.base_pokemon_id).split('_')[0].replace(/^0+/, '') || item.base_pokemon_id;
            pokemonNameMap.set(cleanBaseId, item);
            // Also try with padding
            const paddedId = String(cleanBaseId).padStart(4, '0');
            pokemonNameMap.set(paddedId, item);
          }
          
          // Index by pokemon_id directly (for underscore patterns like "0038_alolan", "0711_large")
          if (id) {
            pokemonNameMap.set(id, item);
            if (id.includes('_')) {
              pokemonNameMap.set(id.replace(/_/g, ''), item);
              pokemonNameMap.set(id.split('_')[0], item);
              // Also try numeric base
              const numericBase = id.split('_')[0].replace(/^0+/, '');
              if (numericBase && /^\d+/.test(numericBase)) {
                pokemonNameMap.set(numericBase, item);
              }
            }
          }
        });
        console.log('[MAPPING] Loaded', pokemonData.count, 'Pokemon mappings from API');
      }
    }
    
    // Load Move mappings
    const moveResponse = await fetch(`${apiUrl}/api/mapping/move`);
    if (moveResponse.ok) {
      const moveData = await moveResponse.json();
      if (moveData.success && moveData.data) {
        moveData.data.forEach(item => {
          const id = item.id?.replace('move_name_', '') || item.move_id || '';
          const moveKey = item.move_key?.toLowerCase() || '';
          
          moveNameMap.set(id, item);
          if (moveKey) {
            moveNameMap.set(moveKey, item);
          }
          if (item.move_english) {
            moveNameMapByEnglish.set(item.move_english.toLowerCase(), item);
          }
          if (item.move_thai) {
            moveNameMapByThai.set(item.move_thai, item);
          }
        });
        console.log('[MAPPING] Loaded', moveData.count, 'Move mappings from API');
      }
    }
    
    mappingsLoaded = true;
  } catch (error) {
    console.warn('[MAPPING] Could not load mappings from API:', error);
    // Fallback to local mappings if API fails
    loadPokemonNameMapping();
    loadMoveNameMapping();
  }
};

// Initialize mappings when module loads
if (typeof window !== 'undefined') {
  loadMappingsFromAPI();
}

/**
 * Query Pokemon mapping from API (async lookup)
 * @param {string} identifier - Pokemon ID or name
 * @returns {Promise<object|null>} - Mapping data or null
 */
const queryPokemonMappingFromAPI = async (identifier) => {
  if (!identifier) return null;
  
  try {
    const apiUrl = getApiBaseUrl();
    const response = await fetch(`${apiUrl}/api/mapping/pokemon/${encodeURIComponent(identifier)}`);
    
    if (response.ok) {
      const data = await response.json();
      if (data.success && data.data) {
        return data.data;
      }
    }
  } catch (error) {
    console.warn('[MAPPING] API query failed:', error);
  }
  
  return null;
};

/**
 * Normalize Pokemon data from different API response formats
 * @param {object} pokemon - Pokemon data from API (could be from rankings, teams, etc.)
 * @param {string} language - Language preference ('th' or 'en')
 * @returns {object} - Normalized Pokemon data
 */
export const normalizePokemonData = (pokemon, language = 'th') => {
  if (!pokemon) return null;

  // Normalize Pokemon ID
  const pokemonId = pokemon.pokemon_id || 
                    pokemon.speciesId || 
                    pokemon.Pokemon_ID || 
                    pokemon.id || 
                    null;

  // Try to find Pokemon name from mapping
  // รองรับรูปแบบ underscore: gourgeist_large, ninetales_alolan, corsola_galarian
  let mappedPokemon = null;
  
  // Build search keys from various sources
  const searchKeys = [];
  
  if (pokemonId) {
    // Try exact match with pokemon_name_ prefix
    if (/^\d+/.test(String(pokemonId))) {
      searchKeys.push(`pokemon_name_${String(pokemonId).padStart(4, '0')}`);
    }
    // Try exact ID match
    searchKeys.push(pokemonId.toLowerCase());
    // Try without underscores
    if (String(pokemonId).includes('_')) {
      searchKeys.push(pokemonId.toLowerCase().replace(/_/g, ''));
      searchKeys.push(pokemonId.toLowerCase().split('_')[0]); // Base name
    }
  }
  
  // Add name-based search keys
  if (pokemon.pokemon_name) {
    const nameLower = pokemon.pokemon_name.toLowerCase();
    searchKeys.push(nameLower);
    if (nameLower.includes('_')) {
      searchKeys.push(nameLower.replace(/_/g, ''));
      searchKeys.push(nameLower.split('_')[0]);
    }
  }
  if (pokemon.name) {
    const nameLower = pokemon.name.toLowerCase();
    searchKeys.push(nameLower);
  }
  if (pokemon.name_th) {
    searchKeys.push(pokemon.name_th);
  }
  if (pokemon.Pokemon_Name_EN) {
    const nameLower = pokemon.Pokemon_Name_EN.toLowerCase();
    searchKeys.push(nameLower);
  }
  if (pokemon.Pokemon_Name_TH) {
    searchKeys.push(pokemon.Pokemon_Name_TH);
  }
  if (pokemon.speciesId) {
    const speciesLower = String(pokemon.speciesId).toLowerCase();
    searchKeys.push(speciesLower);
    if (speciesLower.includes('_')) {
      searchKeys.push(speciesLower.replace(/_/g, ''));
      searchKeys.push(speciesLower.split('_')[0]);
    }
  }
  
  // Try each search key in cache first
  // Priority: exact match > base name match
  for (const key of searchKeys) {
    // Try direct ID/speciesId match first (most reliable)
    mappedPokemon = pokemonNameMap.get(key);
    if (mappedPokemon) {
      console.log(`[MAPPING] Found by ID/speciesId: ${key} -> ${mappedPokemon.name_english || mappedPokemon.name_thai}`);
      break;
    }
    
    // Try English name match
    mappedPokemon = pokemonNameMapByEnglish.get(key);
    if (mappedPokemon) {
      console.log(`[MAPPING] Found by English: ${key} -> ${mappedPokemon.name_english || mappedPokemon.name_thai}`);
      break;
    }
    
    // Try Thai name match
    mappedPokemon = pokemonNameMapByThai.get(key);
    if (mappedPokemon) {
      console.log(`[MAPPING] Found by Thai: ${key} -> ${mappedPokemon.name_english || mappedPokemon.name_thai}`);
      break;
    }
  }
  
  // Debug: Log if mapping not found for underscore patterns
  if (!mappedPokemon && pokemonId && String(pokemonId).includes('_')) {
    console.warn(`[MAPPING] No mapping found for underscore pattern: ${pokemonId}`, {
      searchKeys: searchKeys.slice(0, 5),
      mapSize: pokemonNameMap.size,
      sampleKeys: Array.from(pokemonNameMap.keys()).slice(0, 10)
    });
  }

  // Normalize Pokemon Name - use mapping if available, otherwise use existing values
  // Priority: mappedPokemon > Pokemon_Name_TH/EN (from backend) > other fields
  const pokemonNameTh = mappedPokemon?.name_thai || 
                        pokemon.Pokemon_Name_TH ||  // Backend already mapped
                        pokemon.pokemon_name || 
                        pokemon.name_th || 
                        pokemon.name || 
                        null;

  const pokemonNameEn = mappedPokemon?.name_english || 
                        pokemon.Pokemon_Name_EN ||  // Backend already mapped
                        pokemon.pokemon_name || 
                        pokemon.name || 
                        pokemon.name_th || 
                        null;

  const pokemonName = language === 'th' ? pokemonNameTh : pokemonNameEn;

  // Normalize Fast Move
  const fastMove = pokemon.fast_move || 
                   pokemon.fastMove || 
                   pokemon.fast_move_name || 
                   null;

  // Normalize Charged Moves
  let chargedMoves = [];
  if (pokemon.chargedMoves && Array.isArray(pokemon.chargedMoves)) {
    chargedMoves = pokemon.chargedMoves.filter(Boolean);
  } else {
    const move1 = pokemon.charged_move_1 || pokemon.chargedMove1 || null;
    const move2 = pokemon.charged_move_2 || pokemon.chargedMove2 || null;
    if (move1) chargedMoves.push(move1);
    if (move2) chargedMoves.push(move2);
  }

  // Normalize Image URL
  const imageUrl = pokemon.image_url || 
                   pokemon.imageUrl || 
                   pokemon.image || 
                   null;

  // Normalize Types
  const types = pokemon.pokemon_types || 
                pokemon.types || 
                (pokemon.type1 || pokemon.type2 
                  ? [pokemon.type1, pokemon.type2].filter(t => t && t !== 'none' && t !== '')
                  : []);

  // Normalize Score/Weight
  const score = pokemon.score || 
                pokemon.weight || 
                pokemon.rating || 
                null;

  // Normalize Rank
  const rank = pokemon.rank || 
               pokemon.rank_position || 
               pokemon.position || 
               null;

  // Try to enhance with mapping data if available
  // รองรับรูปแบบ underscore: gourgeist_large, ninetales_alolan
  let mappedNameEn = pokemonNameEn;
  let mappedNameTh = pokemonNameTh;
  
  if (pokemonId && pokemonNameMap.size > 0) {
    // Try multiple lookup patterns
    const searchKeys = [
      pokemonId.toLowerCase(), // Exact ID match
      pokemonId.toLowerCase().replace(/_/g, ''), // Without underscores
      pokemonId.toLowerCase().split('_')[0], // Base name only
      pokemonNameEn?.toLowerCase(),
      pokemonNameTh,
      pokemon.pokemon_name?.toLowerCase(),
      pokemon.name?.toLowerCase(),
      pokemon.speciesId?.toLowerCase()
    ].filter(Boolean);
    
    let mappedPokemon = null;
    for (const key of searchKeys) {
      mappedPokemon = pokemonNameMap.get(key) ||
                     pokemonNameMapByEnglish.get(key) ||
                     pokemonNameMapByThai.get(key);
      if (mappedPokemon) break;
    }
    
    if (mappedPokemon) {
      mappedNameEn = mappedPokemon.name_english || mappedNameEn;
      mappedNameTh = mappedPokemon.name_thai || mappedNameTh;
    }
  }

  // Extract dex_number or base_id from original pokemon object (important for image resolver)
  const dexNumber = pokemon.dex_number || 
                   pokemon.base_id || 
                   (mappedPokemon && mappedPokemon.base_pokemon_id) ||
                   null;
  
  return {
    // Spread original first so our explicit fields override API values
    ...pokemon,
    id: pokemonId,
    pokemon_id: pokemonId,
    speciesId: pokemonId,
    dex_number: dexNumber || pokemonId, // Add dex_number for image resolver
    base_id: dexNumber || pokemonId, // Add base_id for image resolver
    name: mappedNameEn,
    name_th: mappedNameTh,
    pokemon_name: language === 'th' ? mappedNameTh : mappedNameEn,
    Pokemon_Name_EN: mappedNameEn,
    Pokemon_Name_TH: mappedNameTh,
    fast_move: fastMove,
    fastMove: fastMove,
    charged_move_1: chargedMoves[0] || null,
    charged_move_2: chargedMoves[1] || null,
    chargedMoves: chargedMoves,
    image_url: imageUrl,
    imageUrl: imageUrl,
    pokemon_types: types,
    types: types,
    type1: types[0] || null,
    type2: types[1] || null,
    score: score,
    weight: score,
    rank: rank,
    rank_position: rank,
  };
};

/**
 * Normalize move name (handle different formats and use mapping)
 * @param {string} moveName - Move name from API
 * @param {string} language - Language preference ('th' or 'en')
 * @returns {string} - Normalized move name
 */
export const normalizeMoveName = (moveName, language = 'th') => {
  if (!moveName) return null;
  
  // Try to find move from mapping
  const moveNameLower = moveName.toLowerCase();
  let mappedMove = moveNameMapByEnglish.get(moveNameLower) ||
                   moveNameMapByThai.get(moveName);
  
  // If found in mapping, return the appropriate language
  if (mappedMove) {
    return language === 'th' ? mappedMove.move_thai : mappedMove.move_english;
  }
  
  // Otherwise, normalize the move name
  // Handle different formats: SHADOW_CLAW, shadow_claw, Shadow Claw, etc.
  let normalized = moveName
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  
  // Try mapping again with normalized name
  if (moveNameMapByEnglish.size > 0) {
    const mappedMove = moveNameMapByEnglish.get(normalized.toLowerCase()) ||
                       moveNameMapByThai.get(normalized);
    if (mappedMove) {
      return language === 'th' ? mappedMove.move_thai : mappedMove.move_english;
    }
  }
  
  // Special cases for common move names (fallback)
  const moveAliases = {
    'Shadow Claw': 'ชาโดว์คลอว์',
    'Mud Shot': 'มัดช็อต',
    'Breaking Swipe': 'ไวด์เบรกเกอร์',
    'Rock Wrecker': 'ปีนใหญ่หิน',
    'Meteor Mash': 'โคเม็ทพันช์',
    'Earthquake': 'แผ่นดินไหว',
    'Dragon Breath': 'ลมหายใจมังกร',
    'Aqua Tail': 'อควาเทล',
    'Sucker Punch': 'โจมตีแบบไม่คาดคิด',
    'Dazzling Gleam': 'เมจิคัลไชน์',
    'Moonblast': 'มูนฟอร์ซ',
    'Flamethrower': 'พ่นไฟ',
    'Vine Whip': 'แส้เถาวัลย์',
    'Peck': 'จิก',
    'Pound': 'ปัด',
  };
  
  if (language === 'th' && moveAliases[normalized]) {
    return moveAliases[normalized];
  }
  
  return normalized;
};
